import { render, staticRenderFns } from "./Pelunasan.vue?vue&type=template&id=a3575434&"
import script from "./Pelunasan.vue?vue&type=script&lang=js&"
export * from "./Pelunasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports